/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';

export const SvgPostHeartOff = ({ size }) => {
    return (<Svg width={size} height={size} viewBox="0 0 48.09 43.21">
        <Path class="cls-1" fill='#be1e2d' d="M24.12,4.7a13.66,13.66,0,0,1,23.74,6.54A13.24,13.24,0,0,1,44.44,23Q35.85,32.4,27.2,41.76a4.1,4.1,0,0,1-6.26,0C15.19,35.5,9.44,29.28,3.74,23A13.06,13.06,0,0,1,.74,9.5,13,13,0,0,1,11,.31,13.2,13.2,0,0,1,23.55,4.2l.44.45Zm-21.49,9a11,11,0,0,0,3,7.61l17,18.53c1,1.09,1.83,1.09,2.83,0l17-18.53a10.88,10.88,0,0,0,2.9-9,11.08,11.08,0,0,0-20.06-5c-.86,1.22-1.7,1.2-2.58,0A10.76,10.76,0,0,0,12.4,2.7,11,11,0,0,0,2.64,13.65Z" />
    </Svg>)
}

